






































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditWeChatUser from "./editwechatuser.vue";
import Moment from "moment-timezone";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  organizationId: number;
  keyword: string;
  subscribe: number;
  startTime: string;
  endTime: string;
}

@Component({
  components: { EditWeChatUser },
})
export default class WeChatUser extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  treedata: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  splitnum: number = 0.15;

  get list() {
    return this.$store.state.miniappconfig.list;
  }
  get loading() {
    return this.$store.state.miniappconfig.loading;
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.treedata = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.treedata = SearchTree.searnchTree(value, treeList);
  }
  async itemtree() {
    await this.$store
      .dispatch("organization/getCommanyItemTree")
      .then((val) => {
        this.treedata = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("miniappconfig/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("miniappconfig/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.organizationId = item[0].id;
    }
    this.$store.commit("miniappconfig/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("miniappconfig/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "miniappconfig/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.miniappconfig.pageSize;
  }
  get totalCount() {
    return this.$store.state.miniappconfig.totalCount;
  }
  get currentPage() {
    return this.$store.state.miniappconfig.currentPage;
  }
  columns = [
    {
      title: this.L("IndexNo"),
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 150,
      fixed: "left",
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("OpenId"),
      key: "openId",
      width: 160,
      fixed: "left",
      sortable: true,
    },
    {
      title: this.L("Surname"),
      width: 160,
      key: "realName",
      fixed: "left",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.realName,
            },
          },
          params.row.realName
        );
      },
    },
    {
      title: this.L("PhoneNumber"),
      width: 160,
      key: "mobile",
      fixed: "left",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.mobile,
            },
          },
          params.row.mobile
        );
      },
    },
    {
      title: this.L("NickName"),
      width: 160,
      key: "nickName",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.nickName,
            },
          },
          params.row.nickName
        );
      },
    },
    {
      title: this.L("Subscribe"),
      width: 130,
      key: "subscribe",
      render: (h: any, params: any) => {
        let id = params.row.subscribe;
        let str = this.L("Unknown");
        if (id == 0) {
          str = this.L("UnSubscribe");
        } else if (id == 1) {
          str = this.L("Subscribe");
        }
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: str,
            },
          },
          str
        );
      },
    },
    {
      title: this.L("SubscribeTime"),
      key: "subscribetime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.subscribetime == null
            ? ""
            : new Date(params.row.subscribetime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("ReSubscribeTime"),
      key: "resubscribetime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.resubscribetime == null
            ? ""
            : new Date(params.row.resubscribetime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("UnSubscribeTime"),
      key: "unsubscribetime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.unsubscribetime == null
            ? ""
            : new Date(params.row.unsubscribetime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("Sex"),
      width: 130,
      key: "sex",
      render: (h: any, params: any) => {
        let id = params.row.sex;
        let str = this.L("Unknown");
        if (id == 0) {
          str = this.L("Unknown");
        } else if (id == 1) {
          str = this.L("Man");
        } else if (id == 2) {
          str = this.L("Woman");
        }
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: str,
            },
          },
          str
        );
      },
    },
    {
      title: this.L("Country"),
      width: 160,
      key: "country",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.country,
            },
          },
          params.row.country
        );
      },
    },
    {
      title: this.L("Province"),
      width: 160,
      key: "province",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.province,
            },
          },
          params.row.province
        );
      },
    },
    {
      title: this.L("City"),
      width: 160,
      key: "city",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.city,
            },
          },
          params.row.city
        );
      },
    },
    {
      title: this.L("Language"),
      width: 160,
      key: "language",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.language,
            },
          },
          params.row.language
        );
      },
    },
    {
      title: this.L("Headimgurl"),
      width: 160,
      key: "headimgurl",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.headimgurl,
            },
          },
          params.row.headimgurl
        );
      },
    },
    {
      title: this.L("Description"),
      width: 160,
      key: "remark",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.remark,
            },
          },
          params.row.remark
        );
      },
    },
    {
      title: this.L("FromSource"),
      width: 160,
      key: "source",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.source,
            },
          },
          params.row.source
        );
      },
    },
    {
      title: this.L("UnionId"),
      width: 160,
      key: "unionId",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.unionId,
            },
          },
          params.row.unionId
        );
      },
    },
  ];
  async created() {
    this.itemtree();
    this.pagerequest.startTime = Moment()
      .day(-31)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
  }
  data() {
    return {
      paytype: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
